export const updateKeysRegistration = async () => {};

export const initializeKeys = async () => {};
